import { z } from 'zod';

/**
 * JSON-адреса страницы входа и согласия ИИ-агента (005, research R15; specs/005-rules-mcp/contracts/oauth.md,
 * «JSON-адреса страницы входа и согласия»). Одна схема для сервера (модуль `oauth`, T028) и страницы (T029).
 */

/** Право, которое получит токен: код и что право даёт, простыми словами (research R13). */
export const InteractionScope = z.object({ scope: z.string(), text: z.string() });
export type InteractionScope = z.infer<typeof InteractionScope>;

/** Ответ `GET /oauth/interaction/:uid/state`. */
export const InteractionState = z.object({
  step: z.enum(['login', 'consent']),
  /** Учётная запись, под которой подключается агент: логин вошедшего (без ФИО). До входа — нет. */
  account: z.object({ login: z.string() }).optional(),
  /** Клиент агента: адрес документа клиента (CIMD), имя из белого списка, хост документа. */
  client: z.object({ id: z.string(), name: z.string(), host: z.string() }),
  /** Хост адреса возврата; `isLocalhost` — программа на этом компьютере. */
  redirectHost: z.string(),
  isLocalhost: z.boolean(),
  scopes: z.array(InteractionScope),
  /** Нет права «ИИ-агент» (FR-063): согласие невозможно. */
  rightMissing: z.boolean(),
  /** Нет роли из таблицы «Права ролей»: согласие невозможно. */
  noRole: z.boolean(),
});
export type InteractionState = z.infer<typeof InteractionState>;

/** Вход `POST /oauth/interaction/:uid/login` — как у `/api/auth/login`. */
export { LoginRequest as InteractionLoginRequest } from './auth.js';

/** Ответ `POST …/consent` и `POST …/abort`: куда браузер уходит к клиенту агента. */
export const InteractionRedirect = z.object({ redirectTo: z.string().min(1) });
export type InteractionRedirect = z.infer<typeof InteractionRedirect>;
